import {Component, OnDestroy, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {Client} from '../models/clientLocation';
import {AuthService} from '../../services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ClientService} from '../services/client.service';
import {ToastrService} from 'ngx-toastr';
import {ValidationService} from '../../services/validation.service';
import {PhonePipe} from '../../pipes/phone.pipe';
import {UntypedFormBuilder, NgForm, AbstractControl} from '@angular/forms';

@Component({
  selector: 'app-clients-add',
  templateUrl: './clients-add.component.html',
  styleUrls: ['./clients-add.component.less']
})
export class ClientsAddComponent implements OnInit, OnDestroy {
  @ViewChild('form', {}) ngForm: NgForm;
  public clientAccountTypes: any[] = [{name: 'Tenant', id: 1}, {name: 'Employment', id: 2}]; // Id corresponds to enum values in client.cs
  public clientBillingTypes: any[] = [{name: 'Invoicing', id: 1}, {name: 'Point Of Sale', id: 0}]; // Id corresponds to enum values in client.cs

  public model: Client = new Client();
  public formSaving = false;
  public showErrors = false;

  constructor(private _formBuilder: UntypedFormBuilder,
              public phone: PhonePipe,
              public validator: ValidationService,
              public auth: AuthService,
              public location: Router,
              public activatedRoute: ActivatedRoute,
              public clients: ClientService,
              public toastr: ToastrService) {

  }


  public ngOnInit(): void {
  
     
  }


  public ngOnDestroy(): void {
    this.ngForm.resetForm();
  }

  public saveAndContinue(): void {
    if (this.ngForm.valid) {
      this.showErrors = false;
      if (this.model.addresses.length === 0) {
        this.toastr.error('Please complete physical address before saving.');
        return;
      }
      if (this.model.addresses.find(addy => {
        return !addy.isValid;
      })) {
        this.toastr.error('One or more addresses invalid. Please correct any issues before saving.');
        return;
      }

      this.formSaving = true;
      
      // We don't currently have a way for recDec values to be set on client create, so we need to assign the default 85, 75, 45
      // However, we should only do this if the client is Tenant (1) vs Employment (2)
      //RIQ-4755: as of this ticket, scoring values will be set at the API layer in a new scoring model object. No longer need them here.
      this.clients.SaveClient(this.model).subscribe(
        (scc: any) => {
          // this.toastr.info('You client has been saved. please click continue to move on through the client setup process.', 'Client Saved Successfully');
          // once the client saves successfully then we need to refetch the list and set them as the active client.
          const clnt: Client = Object.assign(new Client(), scc);
          this.location.navigateByUrl(`/clients/review/${clnt.id}`);
          this.formSaving = false;
        },
        (err: any) => {
          this.toastr.error(err.error, 'Client Save Failure', {disableTimeOut: true, closeButton: true});
          this.formSaving = false;
        },
      );
    } else {
      this.toastr.error('Please complete all required fields before continuing.');
      this.formSaving = false;
      this.showErrors = true;
    }
  }

  public cancelAddClient(): void {
    this.ngForm.resetForm();
    this.location.navigateByUrl('/clients');
  }
}
